export default {
    props: {
        reports: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            agreed: false,
        };
    },

    methods: {
        agreeTerms() {
            this.$emit('paymentAgree', true);
        },

        close() {
            this.$emit('close', true);
        },
    },
};
